<template>
  <div class="base-layout">
    <template v-if="canShowNavigation">
      <AppBar />
    </template>
    <slot />
    <template v-if="canShowNavigation">
      <AppFooter />
    </template>
    <EmailConfirmationRequiredModal />
  </div>
</template>

<script>
import AppBar from "../components/AppBar.vue";
import AppFooter from "../components/AppFooter.vue";
import EmailConfirmationRequiredModal from "../components/EmailConfirmationRequiredModal.vue";

export default {
  name: "Base",
  components: {
    AppBar,
    AppFooter,
    EmailConfirmationRequiredModal
  },
  computed: {
    canShowNavigation() {
      if (this.$route.name == "Home") return false;
      if (this.$route.name == "DoctorDetails") return false;
      if (this.$route.name == "SchedulePayment") return false;
      if (this.$route.name == "ScheduleLogin") return false;
      if (this.$route.name == "Schedule") return false;
      if (this.$route.name == "Confirmation") return false;
      if (this.$route.name == "WaitingRoom") return false;
      if (this.$route.name == "Consultas") return false;
      if (this.$route.name == "Documentos") return false;
      if (this.$route.name == "Profile") return false;
      if (this.$route.name == "PatientPayments") return false;
      if (this.$route.name == "GuidePage") return false;
      if (this.$route.name == "DoctorDocumentsPage") return false;
      return true;
    }
  }
};
</script>

<style lang="scss">
@import "../scss";
</style>
